// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://uglybjyxbgkjajxkpksj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVnbHlianl4YmdramFqeGtwa3NqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM2MTEyMTYsImV4cCI6MjA3OTE4NzIxNn0.ckvcGFDO3iU7fjWnn0oAtWUkBUvTzDR5WRuUKk_I2Zo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});